module.exports = __webpack_public_path__ + "img/caclose.2f1f3bf2.png";